export const OPEN_CREATE_QUESTION_POPUP = 'OPEN_CREATE_QUESTION_POPUP'
export const CLOSE_CREATE_QUESTION_POPUP = 'CLOSE_CREATE_QUESTION_POPUP'
